<template>
  <div class="dnl:h-full dnl:flex dnl:flex-col dnl:overflow-y-auto dnl:bg-slate-50">
    <AppBar />

    <slot></slot>
  </div>
</template>

<script setup lang="ts">
  import AppBar from '@/components/Shared/AppBar/AppBar.vue';
</script>
